import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { SystemService } from 'app/services/system.service';
import { BridgeListResult } from '../bridge-api.service';
import { urlFor } from '../storage-api/utils';
import { StorageAPIService } from '../storage-api.service';

export interface Alias {
  id: string;
  resourceType: AliasResourceType;
  resourceId: string;
  name: string;
  createdAt: Date;
  groupId: string;
  shareable: boolean;
  sharedBy: string;
}

export enum AliasResourceType {
  DASHBOARD = 'DASHBOARD',
}

@EnableClassTelemetry()
@Injectable()
export class AliasService extends StorageAPIService {
  constructor(
    public http: HttpClient,
    public systemService: SystemService
  ) {
    super(http, systemService);
  }

  createAlias(
    type: AliasResourceType,
    resourceId: string,
    name: string,
    groupId: string,
    shareable: boolean
  ): Promise<Alias> {
    return this.post(`/groups/${groupId}/alias`, {
      resourceType: type,
      resourceId,
      name,
      shareable,
    });
  }

  updateAlias(
    aliasId: string,
    type: AliasResourceType,
    resourceId: string,
    name: string,
    groupId: string,
    shareable: boolean
  ): Promise<Alias> {
    return this.put(`/alias/${aliasId}`, {
      resourceType: type,
      resourceId,
      name,
      shareable,
    });
  }

  getAliasForResource(
    type: AliasResourceType,
    resourceId: string
  ): Promise<BridgeListResult<Alias>> {
    return this.get(`/alias/resource/${type}`, {
      resourceId,
    });
  }

  public getAliasByTypeAndName(type: AliasResourceType, name: string): Promise<Alias> {
    return this.get<Alias>(urlFor(`/alias`), {
      resourceType: type,
      name,
    });
  }

  deleteAlias(id: string) {
    return this.delete(`/alias/${id}`);
  }
}
